import { IToggle } from '@unleash/nextjs';

import {
  IShouldSubscriptionNudgeDisplayed,
  IShowSubscriptionNudge
} from 'src/components/consumptionPage/VideoPlayer/PlayerInterface/PlayerCallbackInterface';

import { getSessionStorage } from './browserStorageHandler';
import { UTM_CAMPAIGN } from './constants/localStorageConstants';
import { FeatureFlagConstants } from './constants/utilConstants';
import { getFeatureFlagConfig } from './RemoteConfig';
import { checkIsTvod } from './TvodHelper/tvodHelper';
import { businessType } from './VideoPlayerUtils/Utils';

export function showSubscriptionNudge({
  setAvodPopupNudgeVisibleAction
}: IShowSubscriptionNudge) {
  if (window && window.videoPlayer && window.videoPlayer.isFullscreen()) {
    window.videoPlayer.exitFullscreen();
  }
  setAvodPopupNudgeVisibleAction(true);
}

export function hideSubscriptionNudge({
  setAvodPopupNudgeVisibleAction
}: IShowSubscriptionNudge) {
  setAvodPopupNudgeVisibleAction(false);
}

export const shouldSubscriptionNudgeDisplayed = ({
  playerRef,
  nudgeType
}: IShouldSubscriptionNudgeDisplayed) => {
  const { singlePlayDetails, playerConfig } = playerRef || {};
  const {
    country = 'IN',
    userType = 'guest',
    mixpanelData: { isEduauraa = false } = {},
    remoteConfig
  } = playerConfig || {};

  const configData: any = getAvodNudgeConfig(remoteConfig) || {};
  if (configData && Object.keys(configData).length) {
    const utmCampaign = getSessionStorage(UTM_CAMPAIGN);
    const {
      enabled_countries,
      pop_up_enabled,
      banner_enabled,
      overlay_enabled,
      organic_user_enabled,
      paid_campaign_enabled,
      guest_user_enabled,
      registered_user_enabled
    } = configData || {};
    const { assetDetails = {} } = singlePlayDetails || {};
    const {
      billing_type,
      business_type,
      asset_type,
      asset_subtype,
      tags = []
    } = assetDetails;
    const isContentPremium = businessType(business_type, billing_type);
    let notEduraContent = !isEduauraa;
    if (
      notEduraContent &&
      tags.length &&
      tags.find((item: string) => item === 'Eduauraa')
    ) {
      notEduraContent = false;
    }
    const isLiveCricketContent =
      asset_type === 1 &&
      (asset_subtype === 'live_event' || asset_subtype === 'sports_vod');
    const isTvodContent = checkIsTvod(business_type);
    if (
      enabled_countries &&
      enabled_countries.includes(country) &&
      ((userType === 'guest' && guest_user_enabled) ||
        (userType === 'register' && registered_user_enabled)) &&
      !isContentPremium &&
      !isTvodContent &&
      !isLiveCricketContent &&
      notEduraContent &&
      !window.isLive &&
      ((nudgeType === 'banner' && banner_enabled) ||
        (nudgeType === 'popup' && pop_up_enabled) ||
        (nudgeType === 'overlay' && overlay_enabled)) &&
      (utmCampaign ? paid_campaign_enabled : organic_user_enabled)
    ) {
      return true;
    }
  }
  return false;
};

/* Return Avod Nudge Config */
export const getAvodNudgeConfig = (remoteConfig: IToggle[]) => {
  const { enabled, payload } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.CONFIG_CONSUMPTION_SUBSCRIPTION_NUDGE
  );
  if (enabled) {
    return payload;
  } else {
    return {};
  }
};
